/**
 * PreBuilt
 * @version     1.0
 */
(function (globals) {

  "use strict";

  var app = {
    id: null,
    templates: window['templates'],
    application: {
      namespace: "PreBuilt",
      version: "1.0"
    },
    documentWidth: 0,
    mainContainer: 'body',
  };

  window['__gites'] = [];

  app.authenticationFailure = function (jqXHR, textStatus, errorThrown) {
    sessionStorage.setItem('authenticationSuccessCallBack', JSON.stringify(jqXHR.responseJSON));
    app.redirect('/my-account/login');
  };

  app.transport = (function () {

    return function () {
      var testMode = false,
        sendDataAsJson = true,
        data = {},
        request = {
          async: true,
          beforeSend: function () {
          },
          cache: true,
          complete: function () {
          },
          data: {},
          processData: false,
          contentType: false,
          error: function () {
          },
          global: true,
          ifModified: false,
          success: function () {
          },
          timeout: 300000,
          type: "GET",
          url: ""
        };
      var events = {
        onBeforeSend: null,
        onSuccess: null,
        onComplete: null,
        onError: null,
        onTimeout: null,
        onAuthenticationFailure: app.authenticationFailure
      };

      return {
        'getEvents': function () {
          return events;
        },

        'get': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "GET";
          if (data) this.setRequestData(data, true);
          this.send(url);
        },

        'head': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "HEAD";
          if (data) this.setRequestData(data, true);
          this.send(url);
        },

        'post': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "POST";
          if (data) this.setRequestData(data, true);
          this.send(url);
        },

        'put': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "PUT";
          if (data) this.setRequestData(data, true);
          this.send(url);
        },

        'delete': function (url, testMode) {
          this.setTestMode(testMode || false);
          request.type = "DELETE";
          this.send(url);
        },

        'setRequestParam': function (param, value) {
          if (param == 'data') return this.setRequestData(value);
          request[param] = value;
          return this;
        },

        setRequestData: function (obj, asJson) {
          sendDataAsJson = (asJson !== false);
          data = obj;
          if (sendDataAsJson === true) {
            request.dataType = "json";
            request.contentType = 'application/json; charset=UTF-8';
          }
          return this;
        },

        setResponseData: function (serializeObject) {
          request.data.serializer = JSON.stringify(serializeObject);
          return this;
        },

        setEvent: function (event, callback) {
          if (typeof callback !== "function") throw(app.log('Error: Event callback is not a function', 'error'));
          events[event] = callback;
          return this;
        },

        setTestMode: function (boolVal) {
          testMode = (boolVal === true);
          return this;
        },

        send: function (url) {
          // check URL
          request.url = url;
          var logKey = request.url.split("?")[0] + '__' + request.type;

          // error with url
          if (!request.url) {
            events.onComplete();
            events.onError({code: 0, message: 'Null or invalid url supplied to ajax call.'});
            return false;
          }

          // prepare data
          if (sendDataAsJson && request.type != 'GET' && request.type != 'HEAD') {
            if (typeof data == "object") {
              data = JSON.stringify(data);
            }
            request.data = data;
          } else {
            if (typeof data == "object" && request.type != 'GET' && request.type != 'HEAD') {
              request.data  = JSON.stringify(data);
            } else {
              $.extend(request.data, data);
            }
          }

          request.beforeSend = function (jqXHR, settings) {
            if (typeof events.onBeforeSend == 'function') {
              events.onBeforeSend(jqXHR, settings);
            }
          };

          request.success = function (responseData, textStatus, jqXHR) {
            window['__gites'][logKey] = {
              'status': jqXHR.status,
              'response': responseData,
              'data': request.data,
              'url': request.url
            };
            if (typeof events.onSuccess == 'function') {
              events.onSuccess(responseData, textStatus, jqXHR);
            }
          };

          request.complete = function (jqXHR, textStatus) {
            if (typeof events.onComplete == 'function') {
              events.onComplete(jqXHR, textStatus);
            }
          };

          request.error = function (jqXHR, textStatus, errorThrown) {

            var error;

            if (jqXHR.status == 403 && typeof events.onAuthenticationFailure == 'function') {
              events.onAuthenticationFailure(jqXHR, textStatus, errorThrown);
            } else if (typeof events.onError == 'function') {
              if (jqXHR.responseJSON) {
                error = {
                  code: jqXHR.status,
                  message: jqXHR.responseJSON
                };
              } else {
                error = {
                  code: jqXHR.status,
                  message: ((jqXHR.responseText) ? jqXHR.responseText : "An error has occurred")
                };
              }
              events.onError(error);
            }

            window['__gites'][logKey] = {
              'status': jqXHR.status,
              'response': error,
              'data': request.data,
              'url': request.url
            };
          };

          if (testMode) {
            var testResponse = {};
            for (var param in request) {
              if (typeof request[param] != 'function') {
                testResponse[param] = request[param];
              }
            }

            for (var event in this.getEvents()) {
              if (typeof this.getEvents()[event] == 'function') {
                testResponse[event] = this.getEvents()[event].toString();
              }
            }
            console.log(testResponse);
            if (typeof events.onComplete == 'function') {
              events.onComplete({}, "test", {});
            }
          } else {
            app.request = $.ajax(request);
          }
        },
        parseResponse: function (jqXHR) {
          var content_type;
          var jsonResponse = {};
          content_type = jqXHR.getResponseHeader('content-type');

          if (content_type) {
            if (content_type.match(/json/)) {
              try {
                jsonResponse = $.parseJSON(jqXHR.responseText);
              } catch (error) {
                console.error("non-standard json response received");
              }
            } else if (content_type.match(/javascript/)) {
              jsonResponse = jqXHR.responseText;
            } else if (content_type.match(/html/)) {
              jsonResponse = {
                html: jqXHR.responseText
              };
            } else {
              console.error("non-standard xhr response received of type: " + content_type);
            }
          }

          return jsonResponse;
        }
      };
    };
  })();

  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  app.generateId = function () {
    return 'dom' + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4()
  };

  $.fn.assignId = function () {
    var _self = $(this);
    var id = _self.attr('id');
    if (typeof id === typeof undefined || id === false) {
      id = app.generateId();
      _self.attr('id', id);
    }
    return id;
  };

  /*	History with Ajax Implementation
   ================================================================= */
  app.initWiseLinks = function () {
    var target = $(app.mainContainer);
    window.wiselinks = new Wiselinks(target);
  };

  /**
   * ToolTip
   */
  app.initTooltip = function () {
    if (app.documentWidth <= 768) {
      $('[data-toggle="tooltip"]').tooltip('dispose');
    } else {
      $('[role="tooltip"]').remove();
      $('[data-toggle="tooltip"]').tooltip();
    }
  };

  app.initWrenchMenu = function () {
    $(document).off('click.data-mobile-menu-trigger').on('click.data-mobile-menu-trigger', '[data-mobile-menu-trigger]', function (e) {
      if (app.documentWidth <= 768) {
        e.preventDefault();
        e.stopPropagation();
        var mobileNavigation = $('.app__navigation--mobile');
        mobileNavigation.toggle();
        var isVisible = mobileNavigation.is(":visible");
        var icon = $('[data-mobile-menu-trigger] i');
        if (isVisible) {
          icon.addClass('fa-window-close').removeClass('fa-wrench');
        } else {
          icon.addClass('fa-wrench').removeClass('fa-window-close');
        }
        return false;
      }
    });
  };

  app.bodyClass = function (url) {
    var parser = document.createElement('a');
    parser.href = url;
    var bodyClass = 'app__body--' + parser.pathname.replace(/\//g, '_').replace(/#/g, '-').replace('_', '');
    $('body').removeClass(function (index, css) {
      return (css.match(/(^|\s)app__body--\S+/g) || []).join(' ');
    }).addClass(bodyClass);

    $('a[href="' + parser.pathname + '"]').addClass('active');
  };

  $(document).off('page:loading').on(
    'page:loading', function (event, $target, render, url) {

      app.loader().show();
    }
  );

  $(document).off('page:done').on(
    'page:done', function (event, $target, render, url, data) {
      var parser = document.createElement('a');
      parser.href = url;
      var logKey = parser.pathname + '__' + 'GET';
      if (typeof wiseLinksXhr != 'undefined') {
        window['__gites'][logKey] = {
          'status': wiseLinksXhr.status,
          'url': url
        };
      }
      app.bodyClass(url);
      app.initTooltip();
      app.initWrenchMenu();
      window.scrollTo(0, 0);

      // Call Global check for social connect
      var appUserSocial = new app.UserSocial();
      appUserSocial.global();
      
    }
  );

  $(document).off('page:always').on(
    'page:always', function (event, xhr, settings) {
      app.loader().hide();
    }
  );

  $(document).off('page:fail').on(
    'page:fail', function (event, $target, status, url, error, code) {
      if (code == 403) {
        app.redirect('/my-account/login');
      }
    }
  );

  app.redirect = function (url, wiselinks) {
    wiselinks = wiselinks || false;
    if (wiselinks == true) {
      window.wiselinks.page.load(url, $(app.mainContainer));
    } else {
      location.href = url;
    }
  };

  $(document).ready(function () {
    app.documentWidth = $(document).width();
    app.initWiseLinks();
    app.bodyClass(document.location.href);
    app.initTooltip();
    app.initWrenchMenu();

  });


  $(window).off('resize.prebuilt').on('resize.prebuilt', function () {
    app.documentWidth = $(document).width();
    app.initTooltip();
    app.initWrenchMenu();
  });

  // SerializeObject
  $.fn.serializeObject = function () {
    return this.serializeJSON();
  };

  /**
   * Buttons loading reset
   * @param fn
   * @returns {*}
   */
  $.fn.button = function (fn) {
    var _this = this;
    if (fn == 'loading') {
      return _this.each(function () {
        $(this).addClass('m-progress').attr('disabled', 'disabled');
      })
    }
    if (fn == 'loading-left') {
      return _this.each(function () {
        $(this).addClass('m-progress m-progress-left').attr('disabled', 'disabled');
        var loadingText = $(this).attr('data-loading-text');
        if (loadingText) {
          $(this).attr('data-original-text', $(this).text());
          $(this).text(loadingText);
        }
      })
    }
    if (fn == 'reset') {
      return _this.each(function () {
        $(this).removeClass('m-progress m-progress-left').removeAttr('disabled');
        var originalText = $(this).attr('data-original-text');
        if (originalText) {
          $(this).text(originalText);
        }
      })
    }
  };

  /**
   * App loader
   * @returns {{show: Function, hide: Function}}
   */
  app.loader = function () {
    var loader = '<div class="app__loader"></div>'
    return {
      'show': function () {
        $('body').append(loader);
      },
      hide: function () {
        $('.app__loader').remove();
      }
    }
  };

  /**
   * Ellipsis View Start
   * @returns {*}
   */
  jQuery.fn.ellipsisView = function () {
    return this.each(function () {
      if ($(this).outerWidth() < $(this)[0].scrollWidth) {
        $(this).closest('[data-row]').find('.btn-view').show();
      }
    });
  };

  $(document).off('click.ellipsis').on('click.ellipsis', '.btn-view', function (e) {
    var text = $(this).closest('[data-row]').find('.ellipsis-content');
    if (text.hasClass('ellipsis')) {
      text.removeClass('ellipsis');
    } else {
      text.addClass('ellipsis');
    }
  });

  /**
   * Flash Messenger
   */
  app.flashMessenger = function () {
    var args = Array.prototype.slice.call(arguments);
    var type = args.shift();
    var message = args.shift();
    alertify.set('notifier', 'position', 'top-right');
    alertify.notify(message, type, 5, function () {
    });
  };

  app.setWarningAlert = function (alertMessage) {
    var alert = '<div class="alert alert-danger" role="alert">' +
      alertMessage +
      '</div>';

    return $(alert).prependTo($('.app__content'));
  };

  /**
   * Convert local date to Utc
   * @param localDate
   * @returns {*}
   */
  app.localToUtc = function (localDate) {
    localDate = moment.tz(localDate.format('YYYY-MM-DD HH:mm:ss'), app.UserObject.timezone);
    var timeStamp = moment(localDate.format()).toDate().getTime();
    return moment(timeStamp).format("YYYY-MM-DD HH:mm:ss");
  };

  /**
   * Convert utc date to Local
   * @param utcDate
   * @returns {*}
   */
  app.utcToLocal = function (utcDate) {
    return moment(moment.utc(utcDate).toDate())
  };

  /**
   * Convert utc date to user timezone
   * @param utcDate
   * @returns {*}
   */
  app.utcToUserTimezone = function (utcDate) {
    var utcCutoff = moment.utc(utcDate, 'YYYYMMDD HH:mm:ss');
    var userTime = utcCutoff.clone().tz(app.UserObject.timezone);
    return userTime.format("YYYY-MM-DD HH:mm:ss");
  };

  /**
   * Lazy Load Image
   * @param container
   */
  app.lazyLoadImage = function (container, callback, callbackAll) {
    $('.lazy:not(.loaded)', container).lazy({
      // called before an elements gets handled
      beforeLoad: function (element) {
        var imageSrc = element.data('src');
        element.parent().addClass('m-progress');
      },

      // called after an element was successfully handled
      afterLoad: function (element) {
        var imageSrc = element.data('src');
        element.parent().removeClass('m-progress');
        if (callback) callback(element);
      },

      // called whenever an element could not be handled
      onError: function (element) {
        var imageSrc = element.data('src');
        console.log('image "' + imageSrc + '" could not be loaded');
      },

      // called once all elements was handled
      onFinishedAll: function () {
        if (callbackAll) callbackAll();
      }
    });
  };

  app.insertAtCursor = function ($txtarea, text) {
    var txtarea = $txtarea[0];

    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
      "ff" : (document.selection ? "ie" : false ) );
    if (br == "ie") {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart('character', -txtarea.value.length);
      strPos = range.text.length;
    }
    else if (br == "ff") strPos = txtarea.selectionStart;

    var front = (txtarea.value).substring(0, strPos);
    var back = (txtarea.value).substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br == "ie") {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart('character', -txtarea.value.length);
      range.moveStart('character', strPos);
      range.moveEnd('character', 0);
      range.select();
    }
    else if (br == "ff") {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }
    txtarea.scrollTop = scrollPos;
  };

  app.HelpVideo = function () {
    $(document).off('click.help__video--' + 'Global').on('click.help__video--' + 'Global', '[data-help-video-modal-trigger]', function (e) {
      var $modal = $('[data-help-video]');
      e.preventDefault();
      $modal.find('iframe').attr('src', $(this).attr('data-src'))
        .on('load', function () {
          $modal.find('.fluidvids').removeClass('m-progress');
        });
      $modal.find('.fluidvids').addClass('m-progress');
      $modal.find('.modal-title').text($(this).attr('data-title'))
      $modal.modal('show');
    }).on('hidden.bs.modal').on('hidden.bs.modal', '[data-help-video]', function () {
      var $modal = $('[data-help-video]');
      $modal.find('iframe').removeAttr('src');
      $modal.find('.fluidvids').removeClass('m-progress');
    });
  };

  app.HelpVideo();

  app.autoSizeInputWidth = function() {
    $(document).off('input.autoSizeInputWidth__' + 'Global').on('input.autoSizeInputWidth__' + 'Global', 'input.autosize-width', function (e) {
      var $input = $(this);
      var $span = $input.next();

      if(!$span.hasClass('span-autosize-width')) {
        $span = $('<span ></span>');
        $span.addClass($input.attr('class'));
        $span.addClass('span-autosize-width');
        $span.insertAfter($input);
      }

      $span.text($input.val());
      $input.width($span[0].offsetWidth);
    });
  };

  app.autoSizeInputWidth();


  app.ResizableTextArea = function() {

    $(document).off('mousemove.resizable_textarea__' + 'Global').on('mousemove.resizable_textarea__' + 'Global', 'textarea.resizable-textarea', function (e) {
      var $textArea = $(this);
      var $parent = $textArea.closest('.form-group');
      var sibLingsWidth = 0;
      $textArea.closest('.col-auto').siblings().each(function() {
        sibLingsWidth +=  $(this).outerWidth(true);
      });
      $textArea.css({'max-width' : $parent.width() - sibLingsWidth - 20});
    });
  };

  app.ResizableTextArea();

  /**
   * Dropzone autoDiscover to false
   * @type {boolean}
   */
  Dropzone.autoDiscover = false;

  // assign global
  globals[app.application.namespace] = app;

})(window);